/* ── Internal modules ───────────────────────────────────────────────────── */
import { type Column } from "../../../components/DataTable";

/* ── Relative imports ───────────────────────────────────────────────────── */
import {
  actionColumn,
  detailsColumn,
  serialNumberColumn,
  statusColumn,
} from "../../schedulers/schedulerColumns";
import { type SchedulerRow } from "../../schedulers/schedulerTypes";

/** The plain data columns, which need nothing from the tab to render. */
const DATA_COLUMNS: Column<SchedulerRow>[] = [
  { key: "moduleName", header: "Module", sortable: true },
  { key: "tool", header: "Assurance Type", sortable: true },
  { key: "importFrequency", header: "Import Frequency", sortable: true },
  { key: "importOn", header: "Import On", sortable: true },
  { key: "time", header: "Schedule Time", sortable: true },
  { key: "lastTriggeredDateStr", header: "Last Import on", sortable: true },
];

export interface PgaSchedulerColumnOptions {
  /** Current page and size, so the Sl. No. column continues across pages. */
  page: number;
  pageSize: number;
  canUpdate: boolean;
  canDelete: boolean;
  canEnableDisable: boolean;
  onToggleStatus: (row: SchedulerRow, next: boolean) => void;
  onViewDetails: (row: SchedulerRow) => void;
  onEdit: (row: SchedulerRow) => void;
  onDelete: (row: SchedulerRow) => void;
}

/**
 * Builds the table's columns for the permissions the current user holds. The
 * Action column is left off entirely when they can neither edit nor delete,
 * rather than rendered empty.
 */
export function buildPgaSchedulerColumns({
  page,
  pageSize,
  canUpdate,
  canDelete,
  canEnableDisable,
  onToggleStatus,
  onViewDetails,
  onEdit,
  onDelete,
}: PgaSchedulerColumnOptions): Column<SchedulerRow>[] {
  const columns: Column<SchedulerRow>[] = [
    serialNumberColumn(page, pageSize),
    ...DATA_COLUMNS,
    statusColumn(onToggleStatus, canEnableDisable),
    detailsColumn(onViewDetails),
  ];

  if (canUpdate || canDelete) {
    columns.push(actionColumn(onEdit, onDelete, { canUpdate, canDelete }));
  }

  return columns;
}
